import { RecipientWithReminders } from '../../../services/types/services'

export type RecipientOption = {
  id: string
  name: string
  relationship: string
}

export type RecipientGroup = {
  letter: string
  recipients: RecipientOption[]
}

export const getDisplayName = (firstName: string, lastName: string): string => {
  return `${firstName} ${lastName}`.trim()
}

export const buildRecipientOptions = (
  recipients: RecipientWithReminders[],
): RecipientOption[] => {
  return recipients
    .map(recipient => ({
      id: recipient.id,
      name: getDisplayName(recipient.firstName, recipient.lastName),
      relationship: recipient.relationship,
    }))
    .sort((a, b) => a.name.localeCompare(b.name))
}

export const groupRecipientsAlphabetically = (
  recipients: RecipientOption[],
): RecipientGroup[] => {
  const groups = new Map<string, RecipientOption[]>()

  recipients.forEach(recipient => {
    const letter = recipient.name.charAt(0).toUpperCase() || '#'
    const existing = groups.get(letter) ?? []
    groups.set(letter, [...existing, recipient])
  })

  return Array.from(groups.entries())
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([letter, groupRecipients]) => ({
      letter,
      recipients: groupRecipients,
    }))
}
